import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Trans } from 'lingui-react';
import Sticky from 'react-sticky-fill';
import { ListTable } from 'base-components';

import CaseDisplayContainer from 'containers/CaseDisplayContainer';

import { shouldBuildLoadingGhosts } from 'utils/favorites';

import ListRowLoading from 'components/_common/ListRowLoading';

import messages from './messages';

const MAX_LOADING_ROWS = 10;

function renderCaseList(cases, isResultsPage) {
  return cases.map((caseInfo) => {
    const caseId = caseInfo.get('id');
    return (
      <CaseDisplayContainer
        datum={caseInfo}
        selectionDisabled={isResultsPage}
        key={caseId}
        type="list"
      />
    );
  });
}

function renderGhostRows(cases, favoritePagination, requesting) {
  if (!shouldBuildLoadingGhosts({ currentCount: cases.size, favoritePagination, requesting })) {
    return null;
  }
  const totalCount = favoritePagination.get('totalCount');
  const count = totalCount ?
    Math.min(MAX_LOADING_ROWS, totalCount - cases.size) :
    MAX_LOADING_ROWS;
  return Array.from(
    { length: count },
    (_, i) => (
      <ListRowLoading
        key={i}
        columnSpans={[1, 3, 2, 4, 2]}
      />
    ),
  );
}

function CasesListView({ cases, favoritePagination, isResultsPage, requesting }) {
  return (
    <ListTable>
      <Sticky style={{ top: '80px' }}>
        <ListTable.Head>
          <ListTable.Header>
            <Trans id={messages.caseNumber} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.status} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.unitNumber} />
          </ListTable.Header>
          <ListTable.Header flex={1.5} minWidth={150}>
            <Trans id={messages.vinNumber} />
          </ListTable.Header>
          <ListTable.Header flex={1.5} minWidth={150}>
            <Trans id={messages.serviceProvider} />
          </ListTable.Header>
          <ListTable.Header flex={2} minWidth={200}>
            <Trans id={messages.complaint} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.estimate} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.etr} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.created} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.severity} />
          </ListTable.Header>
          <ListTable.Header flex={1.5} minWidth={150}>
            <Trans id={messages.notes} />
          </ListTable.Header>
          <ListTable.Header>
            <Trans id={messages.followup} />
          </ListTable.Header>
        </ListTable.Head>
      </Sticky>
      <ListTable.Body>
        {renderCaseList(cases, isResultsPage)}
        {renderGhostRows(cases, favoritePagination, requesting)}
      </ListTable.Body>
    </ListTable>
  );
}

CasesListView.propTypes = {
  cases: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      id: PropTypes.string,
    }),
  ).isRequired,
  favoritePagination: ImmutablePropTypes.map.isRequired,
  isResultsPage: PropTypes.bool,
  requesting: PropTypes.bool.isRequired,
};

CasesListView.defaultProps = {
  favoritePagination: Map(),
  isResultsPage: false,
  requesting: false,
};

export default CasesListView;



// WEBPACK FOOTER //
// ./components/CasesPanel/CasesListView.js